import React from 'react';
import { motion } from 'framer-motion';

const AnimatedEyeIcon = ({ size = 18, color = "currentColor", active = false }) => {
    return (
        <motion.svg 
            width={size} 
            height={size} 
            viewBox="0 -960 960 960" 
            fill={color}
            initial="idle"
            animate={active ? "active" : "idle"}
            whileHover="hover"
            className="animated-eye-icon"
        >
            {/* Outer Almond Shape */}
            <motion.path 
                d="M480-200q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"
                variants={{ 
                    idle: { scaleY: 1, originY: 0.5 },
                    hover: { scaleY: 0.7, originY: 0.5 }, // Squint effect
                    active: { scaleY: 1, originY: 0.5 }
                }} 
                transition={{ duration: 0.2 }}
            />
            {/* Inner Pupil */}
            <motion.path 
                d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Z"
                variants={{ 
                    idle: { x: 0 },
                    active: { x: 0 },
                    hover: { 
                        x: [0, -100, 100, 0], // Scan left and right
                        transition: { 
                            duration: 0.8, 
                            ease: "easeInOut", 
                            repeat: Infinity, 
                            repeatDelay: 0.5 
                        } 
                    } 
                }} 
            />
        </motion.svg>
    );
};

export default AnimatedEyeIcon;
